import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BpfAuditGlobal } from 'src/app/models/bpf/bpf-audit.model';
import { ConfigService } from '../config/config.service';

/**
 * Appelle la route back GET /api/f/bpf/GetAuditGlobalBpf — voir docs/bpf/00-vue-ensemble.md pour
 * le contrat détaillé.
 */
@Injectable({
  providedIn: 'root',
})
export class BpfAuditService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  /** Plusieurs entités : paramètre idEntite répété (?idEntite=1&idEntite=2). */
  getAuditGlobal(idsEntite: number[], dateDebut: Date, dateFin: Date): Observable<BpfAuditGlobal> {
    const entites = idsEntite.map((id) => `idEntite=${id}`).join('&');
    const url = `${this.configService.config.urlApi}/api/f/bpf/GetAuditGlobalBpf`
      + `?${entites}&dateDebut=${this.formatDate(dateDebut)}&dateFin=${this.formatDate(dateFin)}`;
    return this.http.get<BpfAuditGlobal>(url);
  }

  private formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}
